<div class="headerContainer">
  <div class="chatTitle">DiCi</div>
  <div class="chatClose" (click)="close()">
    <i class="bi bi-x"></i>
  </div>
</div>
<div class="chatContainer">
  <div class="mainMessagesContainer" #scrollContainer>
    <div class="messagesContainer">
      @for (item of messages; track item) {
        <div class="messageContainer" [class.mine]="item.message" [class.dici]="item.chatbotResponse">
          <div class="avatar">
            @if (item.chatbotResponse) {
              <img width="32px" src="/assets/dici.png" draggable="false" />
            } @else {
              <ng-lottie class="avatar" width="32px" [options]="avatarAnimationOptions" [style.background-color]="getBackgroundColorForAvatar()" (error)="onError($event)" />
            }
          </div>
          @if (item.chatbotResponse) {
            <div class="textContainer">
              <div class="text" [innerHTML]="item.chatbotResponse | markdown"></div>
            </div>
          }
          @if (item.message) {
            <div class="textContainer">
              <div class="text" [innerHTML]="item.message | markdown"></div>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="chatInputContainer">
    <input type="text" class="chatInput" placeholder="{{ 'chatbot.inputPlaceholder' | translate }}" [(ngModel)]="inputMessage" (keyup.enter)="sendMessage()" />
    <div (click)="sendMessage()" class="sendButton">
      <i class="bi bi-send-fill"></i>
    </div>
  </div>
</div>
